import * as Api from "./api";
import { sendHttpCommandAndWaitForEvent, sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as eventTypes from "./eventTypes";
import * as types from "./actionTypes";
import { getEligibilitiesIsLoaded } from "./selectors";

export function loadPartnerEligibility(documentId, siteId, partnerId) {
  return async (dispatch, getState) => {
    const isLoaded = getEligibilitiesIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      let partnerEligibility = await dispatch(
        sendHttpRequest(Api.getPartnerEligibility(documentId, siteId, partnerId))
      );
      dispatch({ type: types.LOAD_OFFER_PARTNER_ELIGIBILITY_SUCCESS, payload: { partnerEligibility, partnerId } });

      return partnerEligibility;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateOfferPartnerEligibility(data) {
  return async dispatch => {
    try {
      await dispatch(
        sendHttpCommandAndWaitForEvent(Api.updateOfferPartnerEligibility(data), "RunningOfferCommand", [
          eventTypes.OFFER_PARTNER_ELIGIBILITY_UPDATED
        ])
      );
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
